import * as config from '../../wips.config.js';
import { i18n } from '../../i18n/i18n';
import { MainNavigation as Navigation } from '../../main/MainNavigation';
import React from 'react';
import style from './BreadcrumbNavigation.less';
import { WVideoIcon } from '../../core/elements/WVideoIcon';

export interface BreadcrumbMainNavigationProps {
    style?: React.CSSProperties;
    data: any;
}

export interface BreadcrumbMainNavigationState {
    nodePath: any[];
    videoInfo: any;
}

export class BreadcrumbMainNavigation extends React.Component<BreadcrumbMainNavigationProps, BreadcrumbMainNavigationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            nodePath: [],
            videoInfo: null,
        };
    }

    componentDidMount(): void {
        this.init();
    }

    getVideoForNodePath(nodePath: any[]): any {
        if (nodePath.find((node: any) => node.name === 'Startseite')) {
            return { url: 'videos/eTool_07_Start_Funktionsbaum.mp4', name: 'Startseite - Funktionsbaum' };
        }
    }

    init(): void {
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        const nodePath: any[] = Navigation.getNodePath(modul) || [];
        const videoInfo: any = this.getVideoForNodePath(nodePath);
        this.setState({ nodePath, videoInfo });
    }

    render(): JSX.Element {
        const { videoInfo } = this.state;
        console.log('NodePath:', this.state.nodePath);
        return <>
            {videoInfo && config?.enableVideos &&
                <div
                    className={style.startBox}
                    style={{
                        textAlign: 'right', right: 0, left: 275, width: 'auto', margin: 0, marginTop: 9, padding: 0, paddingRight: 30,
                        position: 'absolute'
                    }}
                >
                    <WVideoIcon
                        videoUrl={videoInfo.url}
                        title={i18n(videoInfo.name, 'sys')}
                        isSelection
                    />
                </div>
            }
            <div
                className={style.breadcrumb_navigation}
                style={this.props.style}
            >
                {this.state.nodePath.map((item: any, index: number) =>
                    <div key={`path-${index}`}>
                        {item.name}
                    </div>
                )}
            </div>
        </>;
    }
}
